import { useMutation } from '@tanstack/react-query';
import { escapeRegExp } from 'lodash';
import { ILayout } from 'src/interfaces';

import { requestCCApi } from '../../../utils/axios-utils';

export const useCheckLayoutName = () => {
  return useMutation({
    mutationFn: isLayoutNameAvailable,
  });
};

const isLayoutNameAvailable = async (payload: Partial<ILayout>) => {
  const response = await requestCCApi({
    url: `/layouts?name.regexp=${encodeURIComponent(
      escapeRegExp(payload.name ?? '').trim(),
    )}&channel_name=${payload.channel_name}`,
    method: 'GET',
    data: { data: payload },
  });

  const exactMatches = response.data.some(
    (layout: ILayout) => layout.name.trim() === (payload.name ?? '').trim(),
  );

  return !exactMatches;
};
